import Module from "./Module.vue";

import MesinList from "./views/MesinList.vue";
import SettlementEdcList from "./views/SettlementEdcList.vue";
import UpdateMesinEdc from "./views/UpdateMesinEdc.vue";
import PilihPembayaran from "./views/PilihPembayaran.vue";
import BuatSettlement from "./views/BuatSettlement.vue";
import MesinDetail from "./views/MesinDetail.vue";
import SetoranDetail from "./views/SetoranDetail.vue";
import PembayaranEdcList from "./views/PembayaranEdcList.vue";
import ApproveSettlementEdc from "./views/ApproveSettlementEdc.vue";
import RiwayatPembayaranEdc from "./views/RiwayatPembayaranEdc.vue";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/mesin-edc",
    component: Module,
    children: [
        {
            path: "",
            name: "mesin.edc.list",
            component: MesinList,
            meta: {
                ...requireAuth,
                accessKey: 'edc.read',
            },
        },
        {
            path: "tambah-mesin",
            name: "mesin.edc.add",
            component: UpdateMesinEdc,
            meta: {
                ...requireAuth,
                accessKey: 'edc.create',
            },
        },
        {
            path: "ubah-data-mesin/:id_mesin",
            name: "mesin.edc.update",
            component: UpdateMesinEdc,
            meta: {
                ...requireAuth,
                accessKey: 'edc.update',
            },
        },
        {
            path: "pilih-pembayaran/:id_mesin",
            component: Module,
            children: [
                {
                    path: "",
                    name: "mesin.edc.pilih.pembayaran",
                    component: PilihPembayaran,
                    meta: {
                        ...requireAuth,
                        accessKey: 'edc.settlement',
                    },
                },
                {
                    path: "confirm-batal",
                    name: "mesin.edc.pilih.pembayaran.batal",
                    components: {
                        default: PilihPembayaran,
                        dialog: () => {
                            return import("./components/ConfirmBatalSettlement.vue");
                        },
                    },
                },
                {
                    path: "buat-settlement",
                    name: "mesin.edc.pilih.pembayaran.buat.settlement",
                    component: BuatSettlement,
                    meta: {
                        ...requireAuth,
                        accessKey: 'edc.settlement',
                    },
                },
            ],
        },
        {
            path: "detail/:id_mesin",
            component: Module,
            children: [
                {
                    path: "",
                    name: "mesin.edc.detail",
                    component: MesinDetail,
                    meta: {
                        ...requireAuth,
                        accessKey: 'edc.read',
                    },
                },
                {
                    path: "switch",
                    name: "mesin.edc.detail.switch",
                    components: {
                        default: MesinDetail,
                        dialog: () => {
                            return import("./components/ModalSwitchMesin.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'edc.update',
                    },
                },
                {
                    path: "delete-invalid/:is_saldo",
                    name: "mesin.edc.detail.delete.invalid",
                    components: {
                        default: MesinDetail,
                        dialog: () => {
                            return import("./components/ModalDeleteInvalid.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'edc.delete',
                    },
                },
                {
                    path: "delete-confirm",
                    name: "mesin.edc.detail.delete.confirm",
                    components: {
                        default: MesinDetail,
                        dialog: () => {
                            return import("./components/ModalDeleteConfirm.vue");
                        },
                    },
                },
                {
                    path: "settlement-edc",
                    component: Module,
                    children: [
                        {
                            path: "",
                            name: "mesin.edc.detail.settlement.edc",
                            component: SettlementEdcList,
                            meta: requireAuth,
                        },
                        {
                            path: "export",
                            name: "mesin.edc.detail.settlement.edc.export",
                            components: {
                                default: SettlementEdcList,
                                dialog: () => {
                                    return import("./components/MOdalExportSettlementEdc.vue");
                                },
                            },
                        },
                    ],
                },
                {
                    path: "detail-setoran/:id_settlement",
                    component: Module,
                    children: [
                        {
                            path: "",
                            name: "mesin.edc.detail.setoran",
                            component: SetoranDetail,
                            meta: requireAuth,
                        },
                        {
                            path: "pembayaran",
                            name: "mesin.edc.detail.setoran.pembayaran",
                            component: PembayaranEdcList,
                            meta: requireAuth,
                        },
                        {
                            path: "approve",
                            name: "mesin.edc.detail.setoran.approve",
                            component: ApproveSettlementEdc,
                            meta: requireAuth,
                        },
                        {
                            path: "tolak",
                            name: "mesin.edc.detail.setoran.tolak",
                            components: {
                                default: SetoranDetail,
                                dialog: () => {
                                    return import("./components/ModalTolakSetoran.vue");
                                },
                            },
                        },
                        {
                            path: "export",
                            name: "mesin.edc.detail.setoran.export",
                            components: {
                                default: PembayaranEdcList,
                                dialog: () => {
                                    return import("./components/ModalExportListPembayaranEDC.vue");
                                },
                            },
                        },
                    ],
                },
                {
                    path: "riwayat-pembayaran-edc",
                    component: Module,
                    children: [
                        {
                            path: "",
                            name: "mesin.edc.detail.riwayat_pembayaran_edc",
                            component: RiwayatPembayaranEdc,
                            meta: requireAuth,
                        },
                        {
                            path: "export",
                            name: "mesin.edc.detail.riwayat_pembayaran_edc.export",
                            components: {
                                default: RiwayatPembayaranEdc,
                                dialog: () => {
                                    return import("./components/ModalExportPembayaranEDC.vue");
                                },
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: "selengkapnya",
            name: "mesin.edc.selengkapnya",
            components: {
                default: MesinList,
                dialog: () => {
                    return import("./components/ModalSelengkapnya.vue");
                },
            },
        },
        {
            path: "ringkasan",
            name: "mesin.edc.ringkasan",
            components: {
                default: MesinList,
                dialog: () => {
                    return import("./components/ModalRingkasan.vue");
                },
            },
        },
        {
            path: "back-confirm",
            name: "mesin.edc.back.list",
            components: {
                default: UpdateMesinEdc,
                dialog: () => {
                    return import("./components/ModalBack.vue");
                },
            },
        },
        {
            path: "add-akun",
            name: "mesin.edc.add.akun",
            components: {
                default: UpdateMesinEdc,
                dialog: () => {
                    return import("./components/ModalAddAkun.vue");
                },
            },
        },
        {
            path: "detail-setoran-global/:id_settlement",
            component: Module,
            children: [
                {
                    path: "",
                    name: "mesin.edc.detail_setoran_global",
                    component: SetoranDetail,
                    meta: {
                        ...requireAuth,
                        accessKey: 'settlement.read',
                        
                    }
                },
                {
                    path: "pembayaran",
                    name: "mesin.edc.detail_setoran_global.pembayaran",
                    component: PembayaranEdcList,
                    meta: {
                        ...requireAuth,
                        accessKey: 'settlement.read',
                        
                    }
                },
                {
                    path: "approve",
                    name: "mesin.edc.detail_setoran_global.approve",
                    component: ApproveSettlementEdc,
                    meta: {
                        ...requireAuth,
                        accessKey: 'settlement.confirm',
                        
                    }
                },
                {
                    path: "tolak",
                    name: "mesin.edc.detail_setoran_global.tolak",
                    components: {
                        default: SetoranDetail,
                        dialog: () => {
                            return import("./components/ModalTolakSetoran.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'settlement.confirm',
                        
                    }
                },
                {
                    path: "export",
                    name: "mesin.edc.detail_setoran_global.export",
                    components: {
                        default: PembayaranEdcList,
                        dialog: () => {
                            return import("./components/ModalExportListPembayaranEDC.vue");
                        },
                    },
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
